var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 39,
    rx: 19.5,
    fill: "#95A5B7",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4009_149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3334 13.3333H17.6667C15.8258 13.3333 14.3334 14.8256 14.3334 16.6666V23.3333C14.3334 25.1742 15.8258 26.6666 17.6667 26.6666H24.3334C26.1743 26.6666 27.6667 25.1742 27.6667 23.3333V16.6666C27.6667 14.8256 26.1743 13.3333 24.3334 13.3333Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6667 19.58C23.7489 20.1348 23.6542 20.7014 23.3958 21.1993C23.1375 21.6972 22.7288 22.1009 22.2278 22.3531C21.7267 22.6052 21.159 22.693 20.6052 22.6039C20.0514 22.5148 19.5398 22.2533 19.1432 21.8567C18.7466 21.4601 18.4852 20.9485 18.3961 20.3948C18.3069 19.841 18.3947 19.2732 18.6469 18.7722C18.8991 18.2712 19.3028 17.8625 19.8007 17.6041C20.2985 17.3458 20.8652 17.251 21.42 17.3333C21.986 17.4172 22.5099 17.6809 22.9145 18.0855C23.319 18.4901 23.5828 19.014 23.6667 19.58Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6666 16.3333H24.6733",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4009_149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(13 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.b1c1c3980c0f14ceac40d346f71d9c57.svg";
export { ForwardRef as ReactComponent };